import { combineReducers } from "redux";
import billing from "./billing/billing";
import account from "./global/global";
import allCasesReducer from "./cases/allCasesReducer";
import createCaseReducer from "./cases/createCaseReducer";
import caseNumberReducer from "./cases/getCaseNumberReducer";
import { invoiceHistoryReducer } from "./billing/invoiceHistoryReducer";
import paymentHistoryReducer from "./billing/paymentHistoryReducer";
import viewCaseDetailsReducer from "./cases/viewCaseDetailsReducer";
import contractDetailsReducer from "./contract/contractDetailsReducer";
import technicianAppointmentReducer from "./schedulingportal/technicianAppointmentReducer";

const reducers = combineReducers({
  ACCOUNT: account,
  BILLING: billing,
  CASELIST: allCasesReducer,
  CASENUMBER: caseNumberReducer,
  INVOICE: invoiceHistoryReducer,
  PAYMENTHISTORY: paymentHistoryReducer,
  CREATECASE: createCaseReducer,
  VIEWCASEDETAILS: viewCaseDetailsReducer,
  CONTRACT: contractDetailsReducer,
  TECHNICIANAPPOINTMENT: technicianAppointmentReducer,
});

export default reducers;
